<template>
  <div>
    <HeroSection />
    <ProductsSection />
    <ArticlesSection />
    <EventsSection />
  </div>
</template>

<script>
import HeroSection from "../components/sections/HeroSection/Index.vue";
import ProductsSection from "../components/sections/ProductsSection.vue";
import ArticlesSection from "../components/sections/ArticlesSection.vue";
import EventsSection from "../components/sections/EventsSection.vue";

export default {
  components: {
    HeroSection,
    ProductsSection,
    ArticlesSection,
    EventsSection,
  },
};
</script>
